const supportedTodoWidgetDate = {
  today: 1,
  tomorrow: 1,
};

export type TodoWidgetDate = keyof typeof supportedTodoWidgetDate;

export const isTodoWidgetDateKey = (value?: unknown): value is TodoWidgetDate =>
  typeof value === 'string' ? value in supportedTodoWidgetDate : false;
